// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2vbyA","vLegacy":"SelectSecondary_vLegacy__2Hlc3","error":"SelectSecondary_error__3yMmt","disabled":"SelectSecondary_disabled__10x59"};